import { createContext, useContext, useReducer } from "react";

const ToastsContext = createContext(null);

const ToastsDispatchContext = createContext(null);

export function ToastsProvider({ children }) {
  const [toasts, dispatchToast] = useReducer(toastsReducer, initialToasts);

  return (
    <ToastsContext value={toasts}>
      <ToastsDispatchContext value={dispatchToast}>
        {children}
      </ToastsDispatchContext>
    </ToastsContext>
  );
}

export function useToasts() {
  return useContext(ToastsContext);
}

export function useToastsDispatch() {
  return useContext(ToastsDispatchContext);
}

function toastsReducer(toasts, action) {
  const { type, ...rest } = action;

  switch (type) {
    case "add": {
      return [
        ...toasts,
        {
          id: crypto.randomUUID(),
          ...rest,
        },
      ];
    }
    case "delete": {
      return toasts.filter((toast) => toast.id !== action.id);
    }
    default: {
      throw Error("Unknown action: " + type);
    }
  }
}

const initialToasts = [
  // {
  //   id: crypto.randomUUID(),
  //   variant: "success",
  //   heading: "hello",
  //   subheading: "hello",
  // },
  // {
  //   id: crypto.randomUUID(),
  //   variant: "error",
  //   heading: "Lorem Ipsum",
  //   subheading:
  //     "Est voluptatem eius aliquid neque sapiente dolorem voluptatem. Aperiam in nam corrupti quis cupiditate labore deleniti ut. Odio praesentium maiores nemo consequatur amet eum ut consequatur.",
  // },
];
